import type {
  EventSessionDto,
  FavoriteSessionResponse,
  ListSessionsResponse,
  SessionDetailResponse,
} from "@mvk/shared";
import { apiRequest } from "./client";

export const sessionsApi = {
  list(eventId: string, params?: { q?: string; favorites?: boolean }) {
    const search = new URLSearchParams();
    if (params?.q) search.set("q", params.q);
    if (params?.favorites) search.set("favorites", "1");
    const qs = search.toString();
    return apiRequest<ListSessionsResponse>(
      `/events/${eventId}/sessions${qs ? `?${qs}` : ""}`,
      { audience: "visitor" },
    );
  },

  get(eventId: string, sessionId: string) {
    return apiRequest<SessionDetailResponse>(`/events/${eventId}/sessions/${sessionId}`, {
      audience: "visitor",
    });
  },

  addFavorite(eventId: string, sessionId: string) {
    return apiRequest<FavoriteSessionResponse>(
      `/events/${eventId}/sessions/${sessionId}/favorite`,
      { method: "POST", audience: "visitor" },
    );
  },

  removeFavorite(eventId: string, sessionId: string) {
    return apiRequest<FavoriteSessionResponse>(
      `/events/${eventId}/sessions/${sessionId}/favorite`,
      { method: "DELETE", audience: "visitor" },
    );
  },

  setFavoriteNotification(eventId: string, sessionId: string, notificationEnabled: boolean) {
    return apiRequest<FavoriteSessionResponse>(
      `/events/${eventId}/sessions/${sessionId}/favorite`,
      {
        method: "PATCH",
        body: { notificationEnabled },
        audience: "visitor",
      },
    );
  },
};

export function sessionDtoToUiSession(dto: EventSessionDto) {
  const abs = (url?: string) => {
    const u = (url ?? "").trim();
    if (!u) return undefined;
    if (/^https?:\/\//i.test(u)) return u;
    if (u.startsWith("//")) return `https:${u}`;
    if (/^[a-z0-9.-]+\.[a-z]{2,}([/:?]|$)/i.test(u)) return `https://${u}`;
    return u;
  };
  return {
    id: dto.id,
    eventId: dto.eventId,
    title: dto.title,
    description: dto.description,
    type: dto.type,
    tags: dto.tags?.length ? dto.tags : undefined,
    startTime: dto.startTime,
    endTime: dto.endTime,
    location: dto.location,
    speakers: dto.speakers.map((s) => ({
      id: s.id,
      fullName: s.fullName,
      position: s.position,
      company: s.company,
      bio: s.bio,
      photo: abs(s.photoUrl),
    })),
    capacity: dto.capacity,
    registrationRequired: dto.registrationRequired,
    isFavorite: dto.isFavorite,
    notificationEnabled: dto.notificationEnabled,
    venueTimeZone: dto.venueTimeZone,
  };
}
